import { Observable } from 'rxjs';
import {
  Reservation,
  Reservations,
  ReservationValidations,
  TripLeg,
} from '../data/models/reservation.model';
import httpService from './httpService';

class ReservationsService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_RESERVATION_API_URL.trim();
  }

  public getReservations(): Observable<{
    Reservations: Reservations[];
  }> {
    let url = `${this.apiBase}`;
    return httpService.getJSON(url);
  }
}

const reservationsService = new ReservationsService();

export default reservationsService;
